var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.count)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mx-2 placement",attrs:{"small":"","fab":"","dark":"","color":"red"}},on),[_vm._v(" "+_vm._s(_vm.count)+" ")])]}}],null,false,1467605032)},[_c('span',[_vm._v("There might be some old tasks that are left in a bad state.")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }